<template>
  <div>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-btn @click="logout" outlined>
          <v-icon>
            mdi-logout
          </v-icon>
          Cerrar sesión
        </v-btn>
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

      <v-main>
        <v-container>
          <router-view></router-view>
        </v-container>
      </v-main>
    <NavBottom />
  </div>
</template>
<script>
import NavBottom from '../components/NavBottom'
import { session } from '../services/session'

export default {
  name: 'App',
  components: {
    NavBottom
  },
  methods: {
    logout () {
      session.logout()
      this.$router.push('/auth')
    }
  }
}
</script>
